import React from "react";
import { InputCheckbox } from "@/lib/styles";
import Checkbox from "@/components/Checkbox";

export default function InputCheckboxWrapper(props: any) {
  const { _key, name = "", required = false, label } = props;
  const checkboxFiled = {
    required,
    name,
  };

  return (
    <InputCheckbox
      key={_key}
      onChange={(e: any) => e.target?.parentElement?.classList.remove("error")}
    >
      <Checkbox {...checkboxFiled} value={"yes"}>
        {" "}
        <span dangerouslySetInnerHTML={{ __html: label }}></span>
        {`${required ? "*" : ""}`}
      </Checkbox>
    </InputCheckbox>
  );
}
